import { fabric } from "fabric";
import { Tool } from "../toolGeneric";
import { resolveToolStyle } from "../toolStyle";

export class Rectangle extends Tool {
  constructor() {
    super();
    this.origX = null;
    this.origY = null;
    this.pointer = null;
    this.pointer2 = null;
    this.rect = null;
  }

  create(canvas, event) {
    this.pointer = canvas.getPointer(event.e);
    this.origX = this.pointer.x;
    this.origY = this.pointer.y;
    this.pointer2 = canvas.getPointer(event.e);
    this.rect = new fabric.Rect({
      left: this.origX,
      top: this.origY,
      originX: "left",
      originY: "top",
      ...resolveToolStyle(canvas),
      selectable: true,
      width: this.pointer2.x - this.origX,
      height: this.pointer2.y - this.origY,
    });
    canvas.add(this.rect);
  }

  draw(canvas, event) {
    if (!this.rect) {
      return;
    }
    this.pointer = canvas.getPointer(event.e);
    // Use min() (not abs()) so dragging up/left works in negative scene
    // coordinates too — e.g. after the canvas has been panned.
    const left = Math.min(this.origX, this.pointer.x);
    const top = Math.min(this.origY, this.pointer.y);
    const width = Math.abs(this.origX - this.pointer.x);
    const height = Math.abs(this.origY - this.pointer.y);
    // Excalidraw-style gentle rounded corners, scaled to the smaller side.
    const radius = Math.min(Math.min(width, height) * 0.2, 32);
    this.rect.set({ left, top, width, height, rx: radius, ry: radius });
  }

  done(canvas) {
    if (this.rect.height < 5) {
      canvas.remove(this.rect);
      return;
    }
    this.rect.setCoords();
  }
}
